import * as React from 'react'
import { OnboardingComponentProps } from '.'
import Button from '@doordash/component-button'
import { Text, InlineChildren, Icon } from '@doordash/design-language'
import styled from 'styled-components'

export const SectionLabel = styled(Text).attrs({
  styles: Text.Styles.Label2Emphasis,
})`
  font-weight: ${Text.Weights.Bold};
`
export const USBackgroundCheckEditButton: React.FC<OnboardingComponentProps> = React.memo(
  ({ children, ...props }: OnboardingComponentProps) => {
    return (
      <InlineChildren
        justifyContent={InlineChildren.Justification.SpaceBetween}
        alignItems={InlineChildren.Alignment.Center}
      >
        <SectionLabel>{props.title}</SectionLabel>
        <Button
          onClick={() => props.onChange(!props.value)}
          type={Button.Types.TertiaryPill}
          size={Button.Sizes.Small}
          isInline
        >
          <InlineChildren
            size={InlineChildren.Sizes.XSmall}
            alignItems={InlineChildren.Alignment.Center}
          >
            <Icon size={Icon.Sizes.Medium} type={Icon.Types.EditFill} />
            <Text styles={Text.Styles.Body2Emphasis}>{props.label}</Text>
          </InlineChildren>
        </Button>
      </InlineChildren>
    )
  }
)
